import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { loginAdmin } from "../../actions/auth";
import TokenService from "../../services/token";
import rutas from "../../routes/constants/routes";
import LockIcon from "@mui/icons-material/Lock";
// @ts-expect-error
import ReCAPTCHA from "react-google-recaptcha";

import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Paper,
} from "@mui/material";

const { REACT_APP_CAPTCHA_APIKEY } = process.env;

const Login = (props: any) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    captchaToken: "",
  });

  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (props.success && TokenService.hasSession()) {
      window.location.assign(rutas.DASHBOARD);
    }

    if (TokenService.hasSession()) {
      window.location.assign(rutas.DASHBOARD);
    }
  }, [props.success]);

  const validate = () => {
    const newErrors: any = {};

    if (!formData.email.trim()) {
      newErrors.email = "E-mail é obrigatório";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Digite sua senha";
    }

    if (!formData.captchaToken) {
      newErrors.captchaToken = "Captcha obrigatório";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validate()) return;

    props.login(formData);
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="70vh"
    >
      <Paper elevation={1} sx={{ p: 2, width: 400 }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <Box
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "#E3000B",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LockIcon sx={{ color: "#fff" }} />
          </Box>
        </Box>

        <Typography variant="h6" align="center" gutterBottom>
          ADMIN
        </Typography>

        <form onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth
            label="E-mail"
            name="email"
            margin="normal"
            value={formData.email}
            onChange={handleChange}
            error={Boolean(errors.email)}
            helperText={errors.email}
          />

          <TextField
            fullWidth
            label="Senha"
            name="password"
            type="password"
            margin="normal"
            value={formData.password}
            onChange={handleChange}
            error={Boolean(errors.password)}
            helperText={errors.password}
          />

          <Box mt={2} textAlign="center">
            <ReCAPTCHA
              sitekey={REACT_APP_CAPTCHA_APIKEY}
              onChange={(value: any) =>
                setFormData({ ...formData, captchaToken: value })
              }
            />
            {errors.captchaToken && (
              <Typography variant="caption" color="error">
                {errors.captchaToken}
              </Typography>
            )}
          </Box>

          {props.error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {props.error.response?.data || "Error al iniciar sesión"}
            </Alert>
          )}

          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 3, backgroundColor: "#E3000B" }}
            disabled={props.loading}
          >
            {props.loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Conecte-se"
            )}
          </Button>

          <Box mt={2} textAlign="center">
            {/* <Link to={rutas.RESET_PASWORD_ADMIN}>
              Recuperar contraseña
            </Link> */}
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default connect(
  (state: any) => ({
    session: state.auth.session,
    success: state.auth.success,
    loading: state.auth.loading,
    data: state.auth.data,
    error: state.auth.error,
  }),
  (dispatch) => ({
    login: (loginData: any) => dispatch(loginAdmin(loginData)),
  }),
)(Login);
